;(function ( config, grecaptcha, publicKey, undefined ) {
    var ctaLinks = document.querySelectorAll( '.cta-popup' );
    var popup = document.querySelector( '.habza-cta-popup' );

    if ( ! ctaLinks || ! popup ) {
        return;
    }

    var initiatingElem = undefined;
    var closeBtn = popup.querySelector( '.close-btn' );
    var form = popup.querySelector( 'form' );

    ctaLinks.forEach( function ( link ) {
        link.addEventListener( 'click', function ( e ) {
            e.preventDefault();
            openPopup();
            initiatingElem = this;
        });
    });

    function openPopup () {
        var firstInput = form.querySelector('input:not([type="hidden"]),textarea');
        popup.classList.add( 'habza-cta-popup--active' );
        document.body.style.overflow = 'hidden';
        firstInput.focus();
    }

    function closePopup () {
        popup.classList.remove( 'habza-cta-popup--active' );
        document.body.style.overflow = 'auto';

        if ( initiatingElem ) {
            initiatingElem.focus();
        }
    }

    closeBtn.addEventListener( 'click', function ( e ) {
        e.preventDefault();
        closePopup();
    });

    form.querySelector( 'button' ).addEventListener( 'click', function ( e ) {
        var err = false,
            request = new XMLHttpRequest(),
            data = new FormData(form);

            data.append('applicationType', 'short');

        e.preventDefault();

        form.querySelectorAll( 'input,select,textarea' ).forEach( function ( field ) {
            if ( ! field.checkValidity() ) {
                field.classList.add( 'invalid' );
                err = true;
            } else {
                field.classList.remove( 'invalid' );
            }
        });

        if ( err ) {
            form.reportValidity();
        } else {
            loader.show();
            request.open( 'POST', config.ajaxUrl );
            request.send( data );
            request.addEventListener( 'load', function () {
                var response = JSON.parse( request.response );

                if ( response.success ) {
                        var msgEl = document.createElement( 'div' );
                        msgEl.classList.add( 'form-msg' );
                        msgEl.innerHTML = 'Dziękujemy za wysłanie wniosku. Skontaktujemy się z Państwem wkrótce.';
                        var formHeight = form.getBoundingClientRect().height;
                        form.replaceWith( msgEl );
                        msgEl.parentNode.style.height = formHeight + 'px';
                }
                else {
                    processValidationResults(response.data.errors, form);
                }

                loader.hide();
            });

        }
    });

    form.querySelector( '#agree-all-1' ).addEventListener( 'change', function ( e ) {
        var fields = this.dataset.fields.split( ',' ),
            form = this.closest( 'form' ),
            checked = this.checked;

        fields.forEach( function ( elem ) {
            form[ elem ].checked = checked;
        });
    });

    function generateRecaptchaToken() {
        grecaptcha.ready(function () {
            grecaptcha.execute(publicKey, { action: 'lead' }).then(function (token) {

                var recaptchaResponse = document.getElementById('recaptcha');
                recaptchaResponse.value = token;
            });
        });
    }

    generateRecaptchaToken();

    function processValidationResults(responseErrors, application ) {
        let errors = responseErrors;

        let entries = Object.entries(errors);

        let firstinput = null;

        entries.map( (error) => {

            console.log(error);

            if(error[0] == 'application' && error[1].length > 0) {
                alert(errors[1]);
            }

            let input = application.querySelector(`input[name="${error[0]}"]`);

            if(error[1].length > 0) {
                if(firstinput == null) {
                    firstinput = input;
                    input.focus();
                }

                createErrorDiv(input.parentNode, error[1]);
            }

        });

        generateRecaptchaToken();
    }

    function PreLoader() {

        this.selector = document.getElementById('loader');


        this.show = function () {
            this.selector.style.display = 'block';
        };

        this.hide = function () {
            this.selector.style.display = 'none';
        };
    }

    let loader = new PreLoader();

    var fullTextBtns = document.querySelectorAll('.show-full-text');

    fullTextBtns.forEach(function(btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            showFullText(this.parentElement);
        })
    });

    function showFullText( labelElem ) {
        var fullText = labelElem.querySelector('.form-full-text');
        var isVisible = null === fullText.getAttribute('hidden');

        if (isVisible) {
            fullText.setAttribute('hidden', '');
        } else {
            fullText.removeAttribute('hidden');
        }
    }
}( window.HabzaCtaPopupConfig, window.grecaptcha, window.publicKey ));